
import { getDb } from '../db/db';
import { FuelCard } from '../../types';
import { v4 as uuidv4 } from 'uuid';

export const fuelCardRepository = {
    async get(id: string): Promise<FuelCard | undefined> {
        const db = await getDb();
        return db.get('fuel_cards_v1', id);
    },

    async list(organizationId: string): Promise<FuelCard[]> {
        const db = await getDb();
        // Filter by org in memory
        const all = await db.getAll('fuel_cards_v1');
        return all.filter(c => c.organizationId === organizationId);
    },

    async findByCardNumber(cardNumber: string): Promise<FuelCard | undefined> {
        const db = await getDb();
        return db.getFromIndex('fuel_cards_v1', 'by-cardNumber', cardNumber);
    },

    async findByDriverId(driverId: string): Promise<FuelCard[]> {
        const db = await getDb();
        return db.getAllFromIndex('fuel_cards_v1', 'by-driver', driverId);
    },

    async findByVehicleId(vehicleId: string): Promise<FuelCard[]> {
        const db = await getDb();
        return db.getAllFromIndex('fuel_cards_v1', 'by-vehicle', vehicleId);
    },

    async save(card: FuelCard): Promise<void> {
        const db = await getDb();
        await db.put('fuel_cards_v1', card);
    },

    async create(data: Omit<FuelCard, 'id'>): Promise<FuelCard> {
        const card: FuelCard = {
            ...data,
            id: uuidv4(),
        };
        await this.save(card);
        return card;
    }
};
